import React, { ReactNode } from "react";

import { Card } from "@blueprintjs/core";
import { registerField, registerWidget } from "common/form/register";
import PropertyList from "core/components/editor/properties/PropertyList";
import PropertyReferencePicker from "core/components/editor/properties/PropertyReferencePicker";
import { IFieldProps, IWidgetProps } from "decorator-form";
import IPropertyRecord from "./IPropertyRecord";
import IPropertyReference from "./IPropertyReference";
import IPropertyType from "./IPropertyType";
import { PropertyProvider } from "./PropertyProvider";

export enum PreviewDisplay {
	LEFT,
	BOTTOM
}

export abstract class AbstractPropertyType<S, R> implements IPropertyType<S, R> {
	private _name: string;
	private _label: string;
	private _propertyGroup: string;
	private inputGuid: string;

	constructor(name: string, label: string, group: string) {
		this._name = name;
		this._label = label;
		this._propertyGroup = group;
	}

	public get name() {
		return this._name;
	}

	public get label() {
		return this._label || this._name.charAt(0).toUpperCase() + this._name.slice(1);
	}

	public get propertyGroup() {
		return this._propertyGroup;
	}

	/* The data we store is not the final value that is returned */
	public abstract getValue(value: S, wrapper?: IPropertyRecord<S>): R;

	public abstract getDefaultValue(): S;

	public abstract getInput(value: S, onChange: (value: S) => void,  wrapper?: IPropertyRecord<S>, args?: object): ReactNode;

	protected getSelectInput(): JSX.Element {
		return;
	}

	public getPreviewElement(value: S, minimal: boolean, wrapper?: IPropertyRecord<S>): ReactNode {
		return (
			<Card>
				<h4>
					{wrapper.displayName}
					<h6>{wrapper.type}</h6>
				</h4>
				<p>
					<pre className="bp3-code-block">
						{JSON.stringify(value)}
					</pre>
				</p>
			</Card>
		);
	}

	public static getReferencePickerGuid(type: string, args?: object): string {
		return registerField(AbstractPropertyType.getReferencePicker(type), "object");
	}

	public static getReferencePicker(type: string, args?: object) {
		return (props: IFieldProps<string>) => (
			<PropertyReferencePicker {...props} type={type} args={args}/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/core/util/property/AbstractPropertyType.tsx